'use strict';

/**
 * Narrowest the left panel can be dragged: below this the notebook toolbar
 * starts wrapping.
 */
export const MIN_SIDEBAR_WIDTH = 320;

/** Fraction of the device the left panel opens at before the reader resizes it. */
const DEFAULT_SIDEBAR_WIDTH_RATIO = 1 / 3;

/**
 * Width the left panel renders at, in px: the width the reader dragged it to,
 * otherwise a third of the device. One function owns the number so the panel's
 * own width and the page offset the reader pads with cannot drift apart.
 * @param {Object} params
 * @param {number|null} params.leftWidth - Width the reader dragged the panel to, or null
 * @param {number} params.viewportWidth - Reader width in px
 * @returns {number}
 */
export function resolveSidebarLeftWidth({ leftWidth, viewportWidth }) {
    return Math.round(leftWidth ?? viewportWidth * DEFAULT_SIDEBAR_WIDTH_RATIO);
}
